<template>
  <div class="dashboard-container"> 
    <v-row class="mb-6 stats-row">
      <v-col lg="3" md="6" cols="12" v-for="statCard in visibleStatsCards" :key="statCard.id">
        <StatCard
          :title="statCard.title"
          :value="statCard.value"
          :icon="statCard.icon"
          :color="statCard.color"
          :updated-at="atualDateAndHour"
          :loading="loading"
        />
      </v-col>
    </v-row>
 
    <v-row class="quick-access-row">
      <v-col cols="12">
        <h2 class="quick-access-title">Acesso Rápido</h2>
      </v-col>
      <v-col lg="6" md="12" cols="12" v-if="canRegisterPatient">
        <QuickAccessCards
          title="Cadastrar Paciente"
          description="Adicione um novo paciente ao sistema"
          icon="mdi-plus-circle"
          color="#0e511a"
          to="/cadastrar-paciente"
        />
      </v-col>
      <v-col lg="6" md="12" cols="12" v-if="canRegisterSerology">
        <QuickAccessCards
          title="Cadastrar Sorologia"
          description="Registre os dados de sorologia do paciente"
          icon="mdi-flask-outline"
          color="#0e511a"
          to="/cadastrar-sorologia"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  getMePatients,
  getPcrPatients,
  getFinishedTransplants,
  getPendingTransplants
} from "@/service/LogsService";
import { profileSlug } from "@/helpers/profileSlug";
import { AbilityMixin } from "@/mixins/ability.mixin";
import StatCard from "./StatCard.vue";
import QuickAccessCards from "./QuickAccessCards.vue";
import {compareStr} from "@/utils/compareStrings";
export default {
  mixins: [AbilityMixin],
  components: {
    StatCard,
    QuickAccessCards,
  },
  data: () => ({
    loading: false,
    patienteMe: 0,
    patientePCR: 0,
    finishedTransplants: 0,
    pendingTransplants: 0,
    atualDateAndHour: new Date().toLocaleString(),
  }),

  computed: {
    currentUser() {
      return this.getCurrentSession;
    },

    profile_slug() {
      return profileSlug(this.currentUser.profile)
    },

    isAdmin() {
      return [
        'admin',
        'diretor',
        'plantonistacetcoset',
        'sesabcoset',
        'teccentral'
      ].some(slug => compareStr(this.profile_slug, slug));
    },

    isHemoba() {
      return [
        'techemobaimuno',
        'techemobasorologia'
      ].some(slug => compareStr(this.profile_slug, slug));
    },

    showPCRPatientsData() {
      return this.hasAbility('listpcrdonordata');
    },

    showAllUnities() {
      return this.hasAbility('listallunities');
    },

    canRegisterPatient() {
      return this.hasAbility('caddonor');
    },

    canRegisterSerology() {
      return this.hasAbility('cadserology');
    },

    statsCards() {
      return [
        {
          id: 'me-patients',
          title: 'Pacientes ME',
          value: this.patienteMe,
          icon: 'mdi-account',
          color: '#0e511a',
          show: this.isAdmin || this.showAllUnities,
        },
        {
          id: 'pcr-patients',
          title: 'Pacientes PCR',
          value: this.patientePCR,
          icon: 'mdi-pulse',
          color: '#0e511a',
          show: this.isAdmin || this.showPCRPatientsData || this.showAllUnities,
        },
        {
          id: 'finished-transplants',
          title: 'Transplantes Efetivados',
          value: this.finishedTransplants,
          icon: 'mdi-check-circle',
          color: '#0e511a',
          show: this.isAdmin || this.showAllUnities,
        },
        {
          id: 'pending-donations',
          title: 'Doações Pendentes',
          value: this.pendingTransplants,
          icon: 'mdi-clock-outline',
          color: '#0e511a',
          show: this.isAdmin || this.showAllUnities,
        },
      ];
    },

    visibleStatsCards() {
      return this.statsCards.filter(card => card.show);
    },
  },

  methods: {
    hasAbility(ability) {
      return !!this.currentUser.abilities?.some(item => compareStr(item, ability));
    },
  },

  async created() {
    this.loading = true;
    const unity = this.$store.state.unity_id;

    try {
      const [me, pcr, finished, pending] = await Promise.all([
        getMePatients(unity, this.$store),
        getPcrPatients(unity, this.$store),
        getFinishedTransplants(unity, this.$store),
        getPendingTransplants(unity, this.$store),
      ]);

      this.patienteMe = me.length;
      this.patientePCR = pcr.length;
      this.finishedTransplants = finished.length;
      this.pendingTransplants = pending.length;
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.dashboard-container {
  padding: 16px 0;
}

.stats-row {
  animation: fadeInDown 0.6s ease-out;
}

.quick-access-row {
  animation: fadeInUp 0.8s ease-out;
  margin-top: 32px;
}

.quick-access-title {
  color: #0e511a;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  position: relative;
  padding-left: 12px;
}

.quick-access-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 24px;
  background-color: #0e511a;
  border-radius: 2px;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
